/**
 * [mojdzial1006, paczka MD-KIT, projekt §2.1–2.3, D-1, D-7, decyzje D1–D4] REJESTR OBSZARÓW — „Mój Dział” (`/moj-dzial/…`).
 *
 * Polecenie właściciela z 6.10.2026 („całe UI do zmiany”) i rozstrzygnięcie projektu (rozdz. 0): ta sama powłoka KIT co cztery
 * strony panelu, pięć grup (Do załatwienia · Wnioski · Czas pracy · Zespół · Praca i rozwój), 18 miejsc = 18 dzisiejszych `id`
 * zakładek `MY_DEPT_TABS` pod dzisiejszymi adresami. Rejestr składa się z plików grup (każdy ma właściciela w paczkach obszarów).
 *
 * Flagi strony POZA panelem (D-7): brak `wejsciePanelu` (Mój Dział nie ma wejścia z `/admin`), `bezUstawien` (ostatnia grupa nie
 * jest „Ustawieniami” — konfiguracja modułu siedzi w `/admin/access-control`), `drugaGrupa: "wnioski"` (wyjątek od „druga =
 * Praca” w N-17), `parametryTrwale: ["dzial"]` (D-2, ZM-20: dział przenosi każde przejście), `telefon` (D-16: rząd szukania
 * i akcja główna we własnym rzędzie). `aktywna: false` do MD-WLACZ — prawdziwy `/moj-dzial` rysuje stary hub, a nowy moduł żyje
 * pod trasami deweloperskimi `/moj-dzial-nowy/*` (D21: produkcja nie widzi zmian).
 */
import { GRUPA_STARTU } from "../ksztalt";
import {
    BAZA_MOJEGO_DZIALU, GDZIE_CO_BYLO_MOJEGO_DZIALU, GRUPY_MOJEGO_DZIALU, PARAMETR_DZIALU, SLOWNIK_POJEC_MOJEGO_DZIALU,
    STARE_NAZWY_MIEJSC_MOJEGO_DZIALU, STRONA_MOJEGO_DZIALU, TYTUL_MOJEGO_DZIALU, ZDANIE_MOJEGO_DZIALU, grupyMojegoDzialu,
    stareAdresyMojegoDzialu,
} from "./wspolne";
import { miejsceStartu } from "./start";
import { miejscaWnioskow } from "./wnioski";
import { miejscaCzasu, TRASA_AKTYWNOSCI_OSOBY } from "./czas";
import { miejscaZespolu } from "./zespol";
import { miejscaPracy } from "./praca";

/**
 * Plan źródeł listy „Do załatwienia” (2.9) — osiem odczytów PRZED narysowaniem listy (sufit 8), każdy z zakładką SWOJEGO miejsca
 * (ZM-29; zero `zakladka=pulpit` i zero `dashboard-summary` — D23). Źródło miejsca z kłódką nie jest pytane (2.5).
 * Funkcje `pobierz` / `naWiersze` pisze paczka MD-START (`pages/mojDzial/zrodla/start.js`).
 */
export const PLAN_ZRODEL_STARTU = Object.freeze([
    { id: "wnioski", odczyt: "GET /hr-requests/pending?pageSize=200", miejsce: "wnioski", zakladka: "wnioski", klucz: "ModuleMojDzial" },
    { id: "zakresy", odczyt: "GET /calendar/vacation-ranges/pending", miejsce: "urlopy", zakladka: "urlopy", klucz: "ModuleMojDzial" },
    { id: "zlecenia", odczyt: "GET /my-dept/assignments", miejsce: "wnioski-przelozonego", zakladka: "wnioski-przelozonego", klucz: "ModuleMojDzial" },
    { id: "umowy", odczyt: "GET /my-dept/contracts?days=60", miejsce: "wnioski-przelozonego", zakladka: "wnioski-przelozonego", klucz: "ModuleMojDzial" },
    { id: "oceny", odczyt: "GET /my-dept/evaluation-due", miejsce: "ocena-pracownika", zakladka: "ocena-pracownika", klucz: "ModuleMojDzial" },
    { id: "cele", odczyt: "GET /goals/team", miejsce: "cele", zakladka: "cele", klucz: "ModuleMojDzial" },
    { id: "prosby", odczyt: "GET /my-dept/drive-requests", miejsce: "uprawnienia", zakladka: "uprawnienia", klucz: "ModuleMojDzial" },
    { id: "zalegle", odczyt: "GET /my-dept/overdue-leaves", miejsce: "urlopy", zakladka: "urlopy", klucz: "ModuleMojDzial" },
]);

/** Źródło dopisywane PO narysowaniu listy (pod kreską „Doszło przed chwilą”) i źródła kafli „Wszystkie miejsca” (D-9). */
export const PLAN_ZRODEL_PO_LISCIE = Object.freeze([
    { id: "osiagniecia", odczyt: "GET /career/team", miejsce: "ocena-pracownika", zakladka: "ocena-pracownika" },
]);
export const PLAN_ZRODEL_KAFLI = Object.freeze([
    { id: "sprzet", odczyt: "GET /my-dept/equipment", miejsce: "wyposazenie", zakladka: "wyposazenie" },
    { id: "zadania", odczyt: "GET /my-dept/tasks", miejsce: "todo", zakladka: "todo" },
    { id: "tablice", odczyt: "GET /my-dept/projects", miejsce: "kanban", zakladka: "kanban" },
    { id: "szkolenia", odczyt: "GET /my-dept/elearning-enrollments", miejsce: "e-learning", zakladka: "e-learning" },
    { id: "procedury", odczyt: "GET /api/polityki/dzial", miejsce: "procedury", zakladka: "procedury" },
    { id: "zdalna", odczyt: "GET /my-dept/remote-summary", miejsce: "praca-zdalna", zakladka: "praca-zdalna" },
]);

const mojDzial = {
    strona: STRONA_MOJEGO_DZIALU,
    tytul: TYTUL_MOJEGO_DZIALU,
    zdanie: ZDANIE_MOJEGO_DZIALU,
    baza: BAZA_MOJEGO_DZIALU,
    kluczStrony: "ModuleMojDzial",
    aktywna: false,

    // D-7: strona poza panelem bez ustawień.
    bezUstawien: true,
    drugaGrupa: GRUPY_MOJEGO_DZIALU.wnioski,
    // D-2: filtr trwały — każdy adres budowany przez KIT dokleja go z bieżącego adresu.
    parametryTrwale: [PARAMETR_DZIALU],
    // D-16: telefon strony poza panelem — rząd szukania i akcja główna we własnym rzędzie.
    telefon: { szukajka: true, akcjaWRzedzie: true },
    // Obiekty wspólne dla wielu miejsc (ta sama definicja w każdym — „jedna nazwa, jedno znaczenie”, N-18).
    obiektyWspolne: true,
    // Zapadki źródeł (N-6, N-8, N-9, N-19, MD-3) skanują pliki modułu od pierwszej paczki, nie dopiero od przełączenia.
    skanowanaPrzedPrzelaczeniem: true,

    grupy: grupyMojegoDzialu(),
    obszary: [miejsceStartu, ...miejscaWnioskow, ...miejscaCzasu, ...miejscaZespolu, ...miejscaPracy],
    trasyObiektow: [TRASA_AKTYWNOSCI_OSOBY],

    zrodlaStartu: [],
    sufitOdczytowStartu: 8,
    zrodlaStartuPlan: PLAN_ZRODEL_STARTU,
    /* D-9 (2.9, MD-2, MD-12): odmowa źródła przy pustej liście = szary wiersz „Nie udało się sprawdzić” BEZ białej karty
       „Nic nie czeka” (wejście imienne bez „pulpit” nie może zobaczyć „wszystko załatwione”, gdy źródło nie odpowiedziało). */
    pustaKartaPrzyOdmowie: false,
    /* MD-KIT-2 (2.5, 2.9): szary wiersz odmowy albo awarii źródła to ZAWSZE „Nie udało się sprawdzić: <czego>” + „Spróbuj
       ponownie” — bez „brak klucza” (403 z reguły zasięgu, np. `zakladka-poza-dzialem`, to nie brak klucza) i bez surowego
       angielskiego komunikatu klienta HTTP. */
    zwyklePowodyOdmowy: true,

    stareAdresy: stareAdresyMojegoDzialu,
    stareSlugi: {},

    slownikPojec: SLOWNIK_POJEC_MOJEGO_DZIALU,
    gdzieCoBylo: GDZIE_CO_BYLO_MOJEGO_DZIALU,
    stareNazwyMiejsc: STARE_NAZWY_MIEJSC_MOJEGO_DZIALU,
};

/** Grupa startu to zawsze pierwsza grupa (kontrola budowy — błąd wychodzi przy imporcie, nie na ekranie). */
if (mojDzial.grupy[0].id !== GRUPA_STARTU) throw new Error("Rejestr Mojego Działu: pierwsza grupa musi być „Do załatwienia”.");

export default mojDzial;
